import { render, staticRenderFns } from "./infoCard.vue?vue&type=template&id=17883553&"
import script from "./infoCard.vue?vue&type=script&lang=js&"
export * from "./infoCard.vue?vue&type=script&lang=js&"
import style0 from "./infoCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports